/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_ReadyInputs */

const cs_templates_branding_ready = /** @type {(inputs: Templates_Branding_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připraveno`)
};

const en_templates_branding_ready = /** @type {(inputs: Templates_Branding_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Templates_Branding_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_ready = /** @type {((inputs?: Templates_Branding_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_ready(inputs)
	return cs_templates_branding_ready(inputs)
});